<template>
  <v-row dense>
    <v-col lg="12" cols="12" class="pt-0">
      <v-row dense>
        <v-col lg="12" cols="12" class="pt-0">
          <v-data-table
            calculate-widths
            fixed-header
            :headers="getFilteredHeaders()"
            :items="internalRows"
            :groupBy="groupBy"
            item-key="id"
            class="elevation-1"
            :loading="loading || internalLoading"
            :server-items-length="totalItems"
            :options.sync="pagination"
            :footer-props="footerProps"
            loading-text="Loading... Please wait"
          >
            <!-- Status -->
            <template v-slot:item.status="{ item }">
              <v-tooltip bottom max-width="200">
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    :color="getStatusByName(item.status.name).color"
                    v-on="on"
                  >
                    <v-icon>
                      {{ getStatusByName(item.status.name).icon }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ item.status.title }}</span>
              </v-tooltip>
            </template>

            <!-- lastComment -->
            <template v-slot:item.lastComment="{ item }">
              <template v-if="item.lastComment && item.lastComment.id">
                <div style="cursor: pointer" @click="() => showComments(item)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        class="mr-2"
                        v-on="on"
                        color="primary"
                        size="32"
                        v-if="
                          item.lastComment.user &&
                          item.lastComment.user.id === 1
                        "
                      >
                        mdi-robot
                      </v-icon>
                      <v-icon
                        class="mr-2"
                        v-on="on"
                        color="yellow"
                        size="32"
                        v-else-if="
                          item.lastComment.user &&
                          item.lastComment.user.id === 2
                        "
                      >
                        mdi-face
                      </v-icon>
                      <v-avatar
                        class="mr-2"
                        size="32"
                        v-on="on"
                        v-else-if="
                          item.lastComment.user && item.lastComment.user.picture
                        "
                      >
                        <img
                          :src="
                            item.lastComment.user &&
                            item.lastComment.user.picture
                              ? item.lastComment.user.picture
                              : ''
                          "
                        />
                      </v-avatar>
                    </template>
                    <span
                      v-if="
                        item.lastComment.user && item.lastComment.user.id === 1
                      "
                    >
                      System
                    </span>
                    <span
                      v-else-if="
                        item.lastComment.user && item.lastComment.user.id === 2
                      "
                    >
                      Customer with protected link
                    </span>
                    <span v-else>
                      {{
                        item.lastComment.user ? item.lastComment.user.email : ''
                      }}
                    </span>
                  </v-tooltip>
                  <span>{{ item.lastComment.message }}</span>
                </div>
              </template>
              <template class="text-center" v-else>
                <span>No comments yet...</span>
              </template>
            </template>

            <!-- Multimatch -->
            <template v-slot:item.multimatch_selection="{ item }">
              <v-checkbox
                :disabled="item.status.name === 'imported'"
                class="multimatch-radio-group"
                v-model="multiMatchModels[item.multimatch]"
                @change="() => multiMatchSelected(item)"
                :value="item.id"
              />
            </template>

            <!-- Price -->
            <template v-slot:item.priceInfo.price="{ item }">
              <div class="pa-2">
                <div>
                  <span>
                    ${{ parseFloat(item.priceInfo.price).toFixed(2) }}
                  </span>
                </div>
                <v-container fluid class="d-flex justify-center">
                  <v-tooltip bottom color="white">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        v-on="on"
                        @click="() => handlePriceInfo(item)"
                      >
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </template>
                    <span class="black--text">
                      Click to see more Price information
                    </span>
                  </v-tooltip>
                  <template
                    v-if="
                      item.priceStructure.extendProperties &&
                      item.priceStructure.extendProperties.costComment
                    "
                  >
                    <v-tooltip bottom color="white">
                      <template v-slot:activator="{ on }">
                        <v-icon color="warning" v-on="on">
                          mdi-alert-outline
                        </v-icon>
                      </template>
                      <span class="black--text">
                        {{
                          item.priceStructure.extendProperties &&
                          item.priceStructure.extendProperties.costComment
                        }}
                      </span>
                    </v-tooltip>
                  </template>
                </v-container>
              </div>
            </template>

            <!-- Actions -->
            <template v-slot:item.actions="{ item }">
              <div justify="center" align="center">
                <v-icon
                  class="mr-auto"
                  @click="
                    () => $refs.MainDetails.open(item, isRowDisabled(item))
                  "
                >
                  mdi-information-outline
                </v-icon>
              </div>
            </template>

            <!-- Customer Verified -->
            <template v-slot:item.customer_verified="{ item }">
              <v-checkbox
                class="multimatch-radio-group"
                @change="
                  (value) => handleCustomerVerifiedChange(value, item.id)
                "
                v-model="item.customer_verified"
              />
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-col>
    <PriceInfo ref="PriceInfo" />
    <MainDetails ref="MainDetails" />
  </v-row>
</template>

<script>
import _ from 'lodash';
import PriceInfo from './fileDetails/PriceInfo';
import MainDetails from './fileDetails/MainDetails';
import { DEFAULTS } from '@/constants';
import { processingResultsApiV1 } from '@/api/v1';
import { processingResultsApiV2 } from '@/api/v2';

export default {
  name: 'FileTable',
  computed: {},
  props: {
    headerName: {
      type: String,
      default: ''
    },
    role: {
      type: String,
      default: ''
    },
    rows: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    params: {
      type: Object,
      default: () => ({})
    },
    filters: {
      type: Object,
      default: () => ({})
    },
    menuRowId: {
      type: Number,
      default: undefined
    },
    totalItems: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PriceInfo,
    MainDetails
  },
  data: () => ({
    x: 0,
    y: 0,
    drugsTub: 'Drugs',
    selectedRow: undefined,
    footerProps: {
      'items-per-page-options': [300, 500, 750, 1000, 1250],
      'show-current-page': true,
      'show-first-last-page': true
    },
    pagination: {
      page: 1,
      itemsPerPage: 300
    },
    multiMatchModels: {},
    groupBy: undefined,
    internalRows: [],
    internalLoading: true,
    latestCall: undefined
  }),
  watch: {
    pagination: {
      deep: true,
      handler(newVal, oldVal) {
        if (Object.keys(newVal).length > 2 && Object.keys(oldVal).length > 2) {
          this.$emit('onPaginationChange', this.pagination);
        }
        //
      }
    },
    rows(newValue) {
      this.reCreateMultiMatch();
      this.getGroupByField();
      this.internalRows = [];
      this.internalLoading = true;
      const date = new Date();
      this.latestCall = date;
      this.recurentTableSet(newValue, 1, date, true);
    }
  },
  methods: {
    getScoreIcon(score) {
      //  if score = 1 = smiley face, or green
      // 12:46
      // if score > .95 && < 1,  ok face, or blue
      // 12:47
      // if score > 0 and < .95, yellow

      switch (true) {
        case parseInt(score) === 1:
          return {
            icon: 'mdi-emoticon-excited-outline',
            color: '#7DAC1E'
          };

        case score > 0.95 && score < 1:
          return {
            icon: 'mdi-emoticon-neutral-outline',
            color: 'primary'
          };

        default:
          return {
            icon: 'mdi-emoticon-confused-outline',
            color: '#F8B752'
          };
      }
    },

    getExternalCodeIcon(externalCode) {
      switch (true) {
        case !!externalCode:
          return {
            icon: 'mdi-alpha-e-circle-outline',
            color: 'primary'
          };

        default:
          return {};
      }
    },
    resetPagination() {
      this.pagination = {
        page: 1,
        itemsPerPage: this.pagination.itemsPerPage
      };
    },
    getStatusByName(statusName) {
      const status = DEFAULTS.ROWS_STATUSES[statusName];
      if (status) return status;
      else {
        return DEFAULTS.ROWS_STATUSES.not_reviewed;
      }
    },
    getFilteredHeaders() {
      return this.filters.showPrice || this.filters.showPrice === undefined
        ? this.headers
        : this.headers.filter(
            (header) => !header.type || header.type !== 'pricePart'
          );
    },
    recurentTableSet(rows, numberPerStep, currentCall, opt) {
      if (opt) {
        this.internalRows = rows;
        this.internalLoading = false;
        return;
      }

      if (currentCall !== this.latestCall) return;

      if (!(rows && rows.length)) {
        this.internalLoading = false;
        return;
      }
      if (rows.length <= numberPerStep) {
        this.internalLoading = false;
        this.internalRows = [...this.internalRows, ...rows];

        return;
      } else {
        this.internalRows = [
          ...this.internalRows,
          ...rows.slice(0, numberPerStep)
        ];
        return setTimeout(() => {
          this.recurentTableSet(
            rows.slice(numberPerStep, rows.length),
            numberPerStep,
            currentCall
          );
        }, 50);
      }
    },
    getGroupByField() {
      switch (true) {
        case !!(this.params.multimatch && this.params.multimatch.length) ||
          !!this.filters.multimatch:
          this.groupBy = 'multimatch';
          return;
        case !!(this.params.groupBy && this.params.groupBy.length):
          this.groupBy = 'group_by';
          return;
        case !!(this.params.conflicts && this.params.conflicts.length):
          this.groupBy = 'conflicts';
          return;
        case !!this.params.lastSold:
          this.groupBy = 'sold result';
          return;

        default:
          this.groupBy = undefined;
          return;
      }
    },
    multiMatchSelected(row) {
      const currentMultimatchValue = this.multiMatchModels[row.multimatch];

      this.$emit('setStatus', {
        status: 'ignore',
        multimatch: row.multimatch,
        correct_rows_ids: currentMultimatchValue
      });
    },
    reCreateMultiMatch() {
      this.multiMatchModels = {};
      _.uniqBy(this.rows, (el) => el.multimatch).forEach((row) => {
        const withCorrectStatus = this.rows
          .filter(
            (fRow) =>
              fRow.multimatch === row.multimatch &&
              fRow.status.name === 'correct_by_multimatch'
          )
          .map((fRow) => fRow.id);
        this.$set(
          this.multiMatchModels,
          row.multimatch,
          withCorrectStatus && withCorrectStatus.length ? withCorrectStatus : []
        );
      });
    },
    showComments(row) {
      this.selectedRow = row;
      this.$emit('showComments');
    },
    isRowDisabled(row) {
      return row.import_status === 'SUCCEED' && row.status.name === 'imported';
    },
    getSelectedRow() {
      return this.selectedRow;
    },
    getPagination() {
      return this.pagination;
    },
    async updateRow(row_id, updated) {
      await (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      ).updateRow(this.$route.params.result_id, row_id, updated);
    },
    handleCustomerVerifiedChange(value, rowId) {
      this.updateRow(rowId, { customer_verified: value });
    },
    handlePriceInfo(item) {
      this.$refs.PriceInfo.open(item, true);
    }
  }
};
</script>

<style lang="scss">
.file-edit-content {
  .multimatch-radio-group {
    display: flex;
    flex-direction: column;
    align-items: center;

    .v-input__slot {
      justify-content: center;
    }
  }

  .v-data-table__wrapper {
    height: 53vh;
  }

  .v-data-table {
    td {
      height: 6.5vh !important;

      textarea {
        max-height: 6vh !important;
      }

      padding: 1px !important;
      margin: 0px !important;
      border: thin solid rgba(0, 0, 0, 0.12) !important;

      .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
        > .v-input__control
        > .v-input__slot,
      .v-text-field.v-text-field--enclosed .v-text-field__details {
        padding: 1px !important;
        margin: 0px !important;
      }

      .v-text-field.v-text-field--enclosed {
        padding: 0px !important;
        margin: 0px !important;
      }
    }
  }

  tr:nth-child(even) {
    background: #f5f9fb;
  }

  tr:nth-child(odd) {
    background: #ffffff;
  }

  tr:not(.v-row-group__header) {
    .editable {
      border: thin solid #3a76d1 !important;

      .editable-textarea {
        font-size: 14px !important;
        line-height: 24px !important;
      }
    }

    .text-start {
      text-align: center !important;
    }
  }

  .selected-row {
    background-color: white !important;
  }
}
</style>
